import React from "react";
import Content from "player/components/Content";
import PlayerSizeError from "player/components/PlayerSizeError";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useSearchParams, useParams } from "react-router-dom";

/**
 * Основной компонент плеера, который доступен по адресу /embed/:contentId
 */
export default function Embed() {
  const { contentId } = useParams();

  const isNormalScreen = useMediaQuery(
    "@media (min-width: 200px) and (min-height: 140px)"
  );

  const [searchParams] = useSearchParams();

  const autoPlay = ["1", "true"].includes(searchParams.get("autoplay"));

  const targetStreamId = searchParams.get("streamId");

  const loop = ["1", "true"].includes(searchParams.get("loop"));
  const muted = ["1", "true"].includes(searchParams.get("muted"));
  const chat = ["1", "true"].includes(searchParams.get("chat"));
  const controls = !["0", "false"].includes(searchParams.get("controls"));
  const coverFitMode = ["1", "true"].includes(searchParams.get("coverFitMode"));
  const ignoreSize = ["1", "true"].includes(searchParams.get("ignoreSize"));

  const start = searchParams.has("start")
    ? parseInt(searchParams.get("start"), 10)
    : undefined;

  const finish = searchParams.has("finish")
    ? parseInt(searchParams.get("finish"), 10)
    : undefined;

  if (!isNormalScreen && !ignoreSize) {
    if (process.browser) {
      return <PlayerSizeError />;
    }
  }

  return (
    <Content
      key={contentId}
      contentId={contentId}
      autoPlay={autoPlay}
      loop={loop}
      muted={muted}
      chat={chat}
      start={start}
      finish={finish}
      targetStreamId={targetStreamId}
      controls={controls}
      coverFitMode={coverFitMode}
    />
  );
}
